import { Component, OnInit } from '@angular/core';
import { AuthorizationService, LoggerService } from '@egym/ngx-adm-int';
import * as rolePermissions from 'src/assets/permissions.json';

@Component({
  selector: 'gymfinder-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: { class: 'gymfinder-theme' },
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private authorizationService: AuthorizationService,
    private logger: LoggerService
  ) {}

  ngOnInit() {
    this.logger.info('AppComponent::ngOnInit()', rolePermissions);
    this.authorizationService.addSelfRolePermissions(
      (rolePermissions as any).default
    );
  }
}
